export default function campaigns(state = [], action) {
  switch(action.type) {
    case 'UPDATE_CAMPAIGNS':
      return action.campaigns;

    case 'LOGOUT':
      return [];

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/campaigns.js